import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import SiteFooter from '../components/SiteFooter';

export default function TermsOfServicePage() {
  return (
    <Box sx={{ width: '100%' }}>
      <Container maxWidth="md" sx={{ mx: 'auto', pt: 6, pb: 4, px: 2 }}>
        <Typography variant="h4" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="body1" paragraph>
          By using Medskool.org you agree to abide by these terms. You must be at least
          13 years old and are responsible for any content you post. Do not submit
          material that violates the moderation guidelines or another person's privacy.
        </Typography>
        <Typography variant="body1" paragraph>
          To protect your privacy, course review authorship is hidden from the public.
          Community posts use a separate username and avatar, and future applications
          like tutoring may allow additional identities for each service.
        </Typography>
        <Typography variant="body1" paragraph>
          Courses and community content is moderated. Submissions may be reported or
          removed for reasons such as spam, harassment, hateful or illegal content,
          privacy violations, or misinformation. Repeated violations may lead to
          account suspension.
        </Typography>
        <Typography variant="body1" paragraph>
          Medskool.org is provided "as is" without warranties. We are not liable for
          user-posted content. These terms may change as the project evolves.
        </Typography>
      </Container>
      <SiteFooter />
    </Box>
  );
}
